export const FORGOT_2FA_CODE_VIEW_FORM_FIELDS = {
  Email: 'email',
} as const;

export type Forgot2FaCodeViewFormValues = {
  [FORGOT_2FA_CODE_VIEW_FORM_FIELDS.Email]: string;
};
